import { render, staticRenderFns } from "./ProductVariantForm.vue?vue&type=template&id=13dfa058&scoped=true"
import script from "./ProductVariantForm.vue?vue&type=script&lang=js"
export * from "./ProductVariantForm.vue?vue&type=script&lang=js"
import style0 from "./ProductVariantForm.vue?vue&type=style&index=0&id=13dfa058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dfa058",
  null
  
)

export default component.exports